import { Image } from "@chakra-ui/react";
import React from "react";
import Navbar from "../Components/Navbar";

const AboutDelicious = () => {
  return (
    <div style={{ marginTop: "10%" }}>
      <Image src="https://s3-ap-southeast-1.amazonaws.com/liciousdev/Banner/aboutus_web_1920.jpg" />
    </div>
  );
};

export default AboutDelicious;
